import { SvgIcon, SvgIconProps } from '@material-ui/core';
import React from 'react';

interface IconProps extends SvgIconProps {
  pathColor?: string;
}

const AuditionRequestIcon = (props: IconProps) => {
  return (
    <SvgIcon width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" {...props}>
      <defs>
        <linearGradient x1="-8.757%" y1="0%" x2="125.026%" y2="116.139%" id="kh0wqfb6wa">
          <stop stopColor="#FDC002" offset="0%" />
          <stop stopColor="#C29300" offset="100%" />
        </linearGradient>
      </defs>
      <path
        d="M7.266 0v2.344h15.468V0h2.344v2.344h1.406A3.52 3.52 0 0 1 30 5.859v20.625A3.52 3.52 0 0 1 26.484 30H3.516A3.52 3.52 0 0 1 0 26.484V5.86a3.52 3.52 0 0 1 3.516-3.515h1.406V0h2.344zm20.39 11.016H2.344v15.468c0 .647.525 1.172 1.172 1.172h22.968c.647 0 1.172-.525 1.172-1.172V11.016zM6.796 22.852v2.343H4.454v-2.343h2.344zm4.688 0v2.343H9.141v-2.343h2.343zm4.688 0v2.343h-2.344v-2.343h2.344zm4.687 0v2.343h-2.343v-2.343h2.343zM6.797 18.164v2.344H4.453v-2.344h2.344zm4.687 0v2.344H9.141v-2.344h2.343zm4.688 0v2.344h-2.344v-2.344h2.344zm4.687 0v2.344h-2.343v-2.344h2.343zm4.688 0v2.344h-2.344v-2.344h2.344zm-18.75-4.687v2.343H4.453v-2.343h2.344zm4.687 0v2.343H9.141v-2.343h2.343zm4.688 0v2.343h-2.344v-2.343h2.344zm4.687 0v2.343h-2.343v-2.343h2.343zm4.688 0v2.343h-2.344v-2.343h2.344zM4.922 4.687H3.516c-.647 0-1.172.526-1.172 1.172v2.813h25.312V5.859c0-.646-.525-1.171-1.172-1.171h-1.406V7.03h-2.344V4.688H7.266V7.03H4.922V4.688z"
        fill={props.pathColor || 'url(#kh0wqfb6wa)'}
        fillRule="nonzero"
      />
    </SvgIcon>
  );
};

export default AuditionRequestIcon;
